import apiClient, { getToken } from './client.js';
const base = (wsId) => `/workspaces/${wsId}/realtime`;

export const heartbeat = (wsId, dto) => apiClient.post(`${base(wsId)}/heartbeat`, dto).then(r => r.data);
export const leave = (wsId) => apiClient.post(`${base(wsId)}/leave`).then(r => r.data);
export const getPresence = (wsId) => apiClient.get(`${base(wsId)}/presence`).then(r => r.data);
export const announceView = (wsId, dto) => apiClient.post(`${base(wsId)}/view`, dto).then(r => r.data);

// M-06: Browser EventSource cannot set Authorization headers, so we pass the JWT
// as a query parameter. The backend SseGuard reads ?token= for SSE connections.
export const createEventSource = (wsId) => {
  const token = getToken();
  const qs = token ? `?token=${encodeURIComponent(token)}` : '';
  return new EventSource(`/api/v1/workspaces/${wsId}/realtime/events${qs}`, { withCredentials: true });
};
